import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import Echo from 'laravel-echo'
import Pusher from 'pusher-js';
window.Pusher = Pusher;
import dataTableMixin from './js/Mixin/dataTableMixin'
import { VueMaskDirective } from 'v-mask'

//Pusher.logToConsole = true;

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_APP_KEY,
  cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
  encrypted: true
});

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true
});

Vue.directive('mask', VueMaskDirective);



Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.mixin(dataTableMixin);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created() {
    //this.$axios.defaults.baseURL = 'http://127.0.0.1:8002/api/'
    this.$axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    this.$axios.defaults.headers = {
      "Access-Control-Allow-Origin": "*"
    };

    let tokenLocal = localStorage.getItem('token')
    let tokenSession = sessionStorage.getItem('token')
    if (tokenLocal || tokenSession) {
      //this.$router.push({ 'path': '/main' }).catch(() => { });
    } else {
      if(this.$route.meta.roles == true){
        this.$router.push({ 'path': '/' }).catch(() => { });
      }
    }
  }
}).$mount('#app')
